import React, {Component} from 'react'
import partyColorMap from './partyColorMap'
import find from 'lodash/find'
import values from 'lodash/values'
import forIn from 'lodash/forIn'
import max from 'lodash/max'
import each from 'lodash/each'
import keys from 'lodash/keys'
import config from './config'

const engToNepaliDigit = (ed) => {
  if (ed === null || ed === undefined) return null;
  return String(ed).split("").map(d => String.fromCharCode(d.charCodeAt(0) + 2358)).join("")
}

const allianceLabels = {
  m: {
    label: 'मधेश',
    color: {
      lead: "#FFF59D",
      won: "#FDD835"
    }
  },
  b: {
    label: 'बाम',
    color: {
      lead: "#EF9A9A",
      won: "#E53935"
    }
  },
  l: {
    label: 'लोकतान्त्रिक',
    color: {
      lead: "#A5D6A7",
      won: "#43A047"
    }
  }
}

class StatsContainer extends Component {
  state = {
    data: [],
    loading: false
  }

  componentDidMount() {
    this.setState({loading: true})
    fetch(`${config.api_base_url}/embed/0`)
    .then(r => r.json())
    .then(res => {
      this.setState({
        data: res.data,
        loading: false
      })
    })
  }

  render() {
    const {height, width} = this.props;

    if(this.state.loading) {
      return (
        <div style={{width, height, textAlign: 'center', position: 'relative',fontFamily: 'Helvetica'}}>
          <p style={{fontSize: 12, position: 'absolute', width: 150, height: 10, left: width/2 - 75, top: height/2 - 5 }}>
          प्रतिनिधि सभा निर्वाचन २०७४...
          </p>
        </div>
      )
    }
    //प्रतिनिधि सभा र प्रदेश सभा निर्वाचन २०७४...

    const leading = {2: 0,3: 0,4: 0,11: 0,12: 0, others: 0}
    const won = {2: 0,3: 0,4: 0,11: 0,12: 0, others: 0}

    const allianceWin = {b: 0, l: 0, m: 0 }
    const allianceLead = {b: 0, l: 0, m: 0 }

    const baams = [3, 12, 17]
    const loks = [2, 6, 7, 15, 20]
    const madhes = [4, 11]

    each(this.state.data, (d) => {
      if([2, 12, 3, 4, 11].includes(d.party)) {
        if(d.won) won[d.party]++;
        else leading[d.party]++;
      } else {
        if(d.won) won.others++;
        else leading.others++;
      }

      if(baams.includes(d.party)) {
        if(d.won) allianceWin.b += 1;
        else allianceLead.b += 1;
      }
      if(loks.includes(d.party)) {
        if(d.won) allianceWin.l += 1;
        else allianceLead.l += 1;
      }
      if(madhes.includes(d.party)) {
        if(d.won) allianceWin.m += 1;
        else allianceLead.m += 1;
      }

    })

    let widgetWidth;
    if(width >= 1000) {
      widgetWidth = width/4;
    } else if(width >= 768) {
      widgetWidth = width/2;
    } else {
      widgetWidth = width;
    }
    
    const meta = [
      {label: "अग्रता", data: leading, type: "ind", indicator: 'lead', height, width: widgetWidth},
      {label: "विजयी", data: won, type: "ind", indicator: 'won', height, width: widgetWidth},
      {label: "गठबन्धन अग्रता", data: allianceLead, type: "alliance", indicator: 'lead', height, width: widgetWidth},
      {label: "गठबन्धन विजयी", data: allianceWin, type: "alliance", indicator: 'won', height, width: widgetWidth},
    ]

    return (
      <div>{meta.map(m => (
        <div key={m.label} style={{width: m.width, display: 'inline-block'}}>
          {this.renderChart(m)}
        </div>
      ))}</div>
    )
  }

  renderChart = ({data, height, width, label, indicator, type}) => {
    const lrMargin = 20;
    const heightScale = d3.scaleLinear().domain([0, max(values(data))]).range([2, 170]);
    const widthScale = d3.scale.ordinal().domain(keys(data)).rangeBands([0, width - lrMargin], .2);

    const bars = [];
    
    forIn(data, (count, party) => {
      let color;
      let barLabel;
      
      if(type == "alliance") {
        color = allianceLabels[party].color[indicator];
        barLabel = allianceLabels[party].label
      } else {
        const predicate = party == "others" ? 0 : Number(party);
        color = find(partyColorMap, {id: predicate})[indicator];
        barLabel = find(partyColorMap, {id: predicate}).label;
      }
      bars.push(
        <g key={ party }>
          <rect 
              key={party}
              height={heightScale(count)} 
              width={widthScale.rangeBand()} 
              transform={`translate(${widthScale(party)}, ${200 - heightScale(count)})`}
              fill={color}
            />
            <text 
            textAnchor="middle"
            style={{ fontSize: 16, textAlign: 'center', fill: 'rgba(0,0,0,.6)'}}
            transform={`translate(${widthScale(party) + (widthScale.rangeBand()/2)}, ${195 - heightScale(count)})`}
          >
            {engToNepaliDigit(count)}
          </text>
          <text 
            textAnchor="middle"
            style={{ fontSize: 12, textAlign: 'center', fill: 'rgba(0,0,0,.6)'}}
            transform={`translate(${widthScale(party) + (widthScale.rangeBand()/2)}, 220)`}
          >
            {barLabel}
          </text>
        </g>
      )
    })
    return (
      <div key={data.label}>
        <h5 style={{textAlign: 'center'}}>{label}</h5>
        <svg height={250} width={width - lrMargin}>
          { bars }
          <line x1={0} y1={200} x2={width - lrMargin} y2={200} stroke="rgba(0,0,0,.25)" />
        </svg>
      </div>
    )
  }
}

export default StatsContainer;


// WEBPACK FOOTER //
// ./src/StatsContainer.js